import { Collapse } from "antd";
import './home.css';
import { BaseComponent, IBaseProps, IBaseStates } from "../components/infrastructure/baseComponent";
import AppContext from "../components/infrastructure/appContext";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";

interface IFaqProps extends IBaseProps {

}
interface IFaqStates extends IBaseStates {

}
export class Faq extends BaseComponent<IFaqProps, IFaqStates>{
    static contextType = AppContext;
    constructor(props: IFaqProps) {
        super(props)

        this.state = {
            isAuthorized: true,
            loading: true,
            windowSize: window.innerWidth <= 765 ? 1 : 2
        };
    }
    componentDidMount() {
        super.componentDidMount();
        this.setLoading(false);
    }
    virtualRender() {
        const header = this.getPageHeader({ title: "پرسش های متداول", onBack: () => window.history.back() });

        return (
            <div style={{ direction: 'rtl', height: "100vh" }}>
                <div >
                    {header}
                </div>
                <div className="wrapper" style={{ width: "100%", display: 'flex', marginTop: 40 }} >
                    <Collapse
                        className="custom-scroll"
                        style={{ width: "100%", backgroundColor: 'transparent', border: 'none', color: 'darkslategrey' }}
                        accordion
                    >
                        <CollapsePanel key="1" header={<b>سوال: چگونه می‌توانم ثبت خسارت نمایم؟</b>}>
                            <b>پاسخ : </b>
                            <>ثبت خسارت در سایت https://claim.zobdeh.org/login</>
                            <ul>
                                <ol >1- وارد سایت “https://claim.zobdeh.org/login” شوید.</ol>
                                <ol >2- در بالای صفحه سایت در تَب "ورود بیمه‌گزار/مشتری"، با وارد کردن کد ملّی و دریافت رمز عبور یکبار مصرف وارد "پنل بیمه‌گزار/مشتری" خود شوید.</ol>
                                <ol >3- وارد قسمت "ثبت خسارت" شوید. از قسمت "بیمه نامه‌های من"، بیمه نامه مد نظر که خسارت خورده‌اید را انتخاب کنید و فرم "ثبت خسارت" را بصورت کامل تکمیل نمایید.</ol>
                                <ol >4- در مرحله بعدی "آپلود مدارک خسارت" را تکمیل و بر روی"ارسال مدارک" کلیک و مدارک را ارسال نمایید.</ol>
                                <ol >5- کارشناسان خسارت بیمه‌گر پس از بررسی پرونده خسارت، ظرف مدت حداکثر 1 روز کاری، نسبت به ارجاع پرونده به مراکز تخصصی ارزیابی تجهیزات الکترونیک اقدامات لازم را انجام خواهند داد و از طریق پیام کوتاه زمان و آدرس مراجعه حضوری به مرکز ارزیابی برای شما ارسال خواهد شد.</ol>
                            </ul>
                        </CollapsePanel>

                        <CollapsePanel key="2" header={<b>سوال : برای دریافت خسارت چه مدارکی لازم دارم؟</b>} >
                            <p>
                                <b>پاسخ : </b>
                                پس از ثبت خسارت در نرم افزار خسارت و دریافت پیامک زمان و آدرس مراجعه حضوری به مرکز ارزیابی، بیمه‌گزار محترم جهت بررسی خسارت می‌بایست کارت شناسایی معتبر، جعبه دستگاه و متعلقات آن، کارت بیمه نامه، پرینت گواهی بیمه نامه را به همراه داشته باشد.
                            </p>
                        </CollapsePanel>

                        <CollapsePanel key="3" header={<b>سوال : در صورت سرقت دستگاه چه مدارکی جهت دریافت خسارت الزامی می‌باشد؟</b>}>
                            <b>پاسخ : </b>
                            <ul>
                                <ol> 1) نامه از مراجع انتظامی (حتماً اظهارات بیمه گزار توسط آگاهی در خصوص سرقت به تأیید مراجه انتظامی رسیده باشد.)</ol>
                                <ol> 2) نامه از مراجع قضایی (حتماً اظهارات بیمه گزار توسط نامه مراجع قضایی و دادگاه به تأیید مراجع قضائی رسیده باشد.)</ol>
                                <ol> 3) ثبت دستگاه در سایت همیاب 24 و همراه داشتن پرینت رسید پرداخت.</ol>
                                <ol> 4) ارائه جعبه و متعلقات داخل جعبه الزامی است، در غیر اینصورت بیمه‌گر مجاز و محق خواهد بود ارزش بازیافتی موارد مزبور را مطابق نظر کارشناسان مستقر در مرکز تخصصی از مبلغ خسارت کسر نماید.</ol>
                                <ol> 5) در زمان بروز خسارت کُلی و یا سرقت جهت دریافت خسارت بیمه‌گزار موظف است رجیستر گوشی را به مالکیت بیمه سامان انتقال دهد، در غیر اینصورت شرکت بیمه سامان تعهدی در خصوص پرداخت خسارت نخواهد داشت.</ol>
                                <ol> 6) ارائه مستندات و شواهد لازم و کافی مبنی بر وقوع سرقت شامل فیلم دوربین مداربسته موقعیت وقوع سرقت و استشهاد محلی ضروری می باشد.</ol>
                                <ol> 7) ارائه فاکتور خرید.</ol>
                                <ol> 8) تاریخ سرقت با تأیید شده توسط مراجع انتظامی می‌بایست در دوره اعتبار بیمه‌نامه مربوطه باشد.</ol>
                                <ol> 9) همراه داشتن مدارک شناسایی (کارت ملّی یا شناسنامه) جهت احراز هویت بیمه گذار.</ol>
                                <ol> 10) ارائه فاکتور خرید دستگاه در صورت وجود. </ol>
                            </ul>

                            <b>نکات مهم :</b>
                            <ul>
                                <ol>1) در صورت عدم ارائه هریک از لوازم جانبی موجود در جعبه دستگاه توسط بیمه گزار محترم، هزینه مربوطه از مبلغ پرداختی خسارت کسر خواهد گردید. (جعبه، شارژر، سیم شارژر، هندزفری، قلم، بند ساعت هوشمند، باطری لپ تاپ)</ol>
                                <ol>2) مبلغ خسارت پس از انجام انتقال مالکیت دستگاه سرقت شده به شرکت بیمه سامان انجام خواهد گرفت.</ol>
                                <ol>3) بررسی مدارک ارائه شده توسط کارشناسان خسارت و پرداخت خسارت توسط شعبه مربوطه.</ol>
                                <ol>4) در زمان بروز خسارت کلی و یا سرقت جهت دریافت خسارت بیمه گزار موظف است رجیستر گوشی را به مالکیت بیمه سامان انتقال دهد، در غیراینصورت بیمه‌گر تعهدی در خصوص پرداخت خسارت نخواهد داشت.</ol>
                            </ul>

                        </CollapsePanel>

                        <CollapsePanel key="4" header={<b>سوال : پوشش سرقت در بیمه نامه تجهیزات الکترونیکی به چه صورت می‌باشد؟</b>}>
                            <b>پاسخ : </b>
                            <ul>
                                <li>
                                    سرقت با شکست حرز: مورد پوشش بیمه نامه تجهیزات الکترونیک می‌باشد. شکست حرز به معنای شکست مانع برای سرقت است مثلاً درب، قفل یا پنجره برای انجام دزدی است. سرقت معمولی بدون رخداد شکست حرز مشمول این طرح قرار نمی‌گیرد.
                                </li>
                                <li>
                                    سرقت کُلی : مورد پوشش بیمه نامه تجهیزات الکترونیک می‌باشد. سرقت تجهیزات بیمه شده به هر نحوی را شامل می‌باشد.
                                </li>
                            </ul>
                        </CollapsePanel>

                        <CollapsePanel key="5" header={<b>سوال : آیا “بیمه سامان” خسارت کامل موبایل، تبلت، لپ تاپ و ... را به من پرداخت می کند؟</b>}>
                            <p>
                                <b>پاسخ : </b>
                                بله. در صورتیکه کارشناسان مراکز خدمات تخصصی تأیید نمایند که امکان تعمیر و برطرف کردن کامل مشکلات دستگاه شما وجود نداشته باشد (خسارت کلی)، هزینه آن مطابق با شرایط مندرج در گواهی بیمه نامه و با کسر فرانشیز به شما پرداخت می‌شود.
                            </p>
                        </CollapsePanel>

                        <CollapsePanel key="6" header={<b>سوال : مبنای محاسبه پرداخت خسارت چیست؟</b>}>
                            <p>
                                <b>پاسخ : </b>
                                خسارت پرداختی به بیمه گذاران محترم مطابق با گواهی بیمه نامه و با کسر فرانشیز و کسورات قانونی انجام خواهد شد. (جهت اطلاع از مقدار فرانشیز و نحوه محاسبه پرداخت خسارت، بیمه نامه توسط بیمه گذاران محترم مطالعه شود.)
                            </p>
                        </CollapsePanel>

                        <CollapsePanel key="7" header={<b>سوال : اگر برای دستگاه من حادثه‌ای اتفاق بیافتد و من از گواهی بیمه خود برای جبران خسارت استفاده کنم، آیا بیمه نامه من منقضی می‌شود؟</b>}>
                            <p>
                                <b>پاسخ : </b>
                                بله. مطابق شرایط مندرج در بیمه نامه فقط یکبار پرداخت خسارت (جزئی یا کلی یا سرقت با شکست حرز) در طول مدت اعتبار بیمه نامه انجام خواهد شد و پس از پرداخت یکبار خسارت، اعتبار نخواهد داشت.
                            </p>
                        </CollapsePanel>

                        <CollapsePanel key="8" header={<b>سوال : من در تهران سکونت ندارم. برای دریافت خسارت چکار کنم؟</b>}>
                            <p>
                                <b>پاسخ : </b>
                                پس از ثبت خسارت در سایت claim.zobdeh.org و بررسی مدارک ، شماره تماس و آدرس نزدیک‌ترین مرکز ارزیابی به بیمه‌گزار محترم جهت مراجعه حضوری از طریق پیامک اطلاع رسانی می‌گردد.
                            </p>
                        </CollapsePanel>

                        <CollapsePanel key="9" header={<b>سوال : من در تهران سکونت ندارم. آیا برای استفاده از خدمات فنی شما باید حضوری مراجعه کنم؟</b>}>
                            <p>
                                <b>پاسخ : </b>
                                خیر. کافیست در سایت claim.zobdeh.org ثبت خسارت را بصورت آنلاین انجام دهید یا با مراجعه به شعبه شهر مربوطه نسبت به تشکیل پرونده اقدامات لازم انجام دهید. در صورت لزوم و توافق طرفین دستگاه توسط شعبه مربوطه به تهران جهت ارزیابی و تعمیرات ارسال می شود.
                            </p>
                        </CollapsePanel>

                        <CollapsePanel key="10" header={<b>سوال : مدت زمانی که تعمیر دستگاه من طول می کشد چقدر است؟</b>}>
                            <p>
                                <b>پاسخ : </b>
                                مراکز خدمات فنی ما سعی بر آن دارند که حداکثر در مدت یک هفته کاری نسبت به تعمیر و تحویل دستگاه شما اقدام کنند. مدت زمان دقیق انجام تعمیرات بستگی به نوع خسارت وارده و قطعات یدکی مورد نیاز دارد و ممکن است در بعضی موارد خاص طولانی تر شود. اطمینان از کیفیت انجام تعمیرات و رضایت شما برای ما بالاترین اولویت را دارد.
                            </p>
                        </CollapsePanel>

                        <CollapsePanel key="11" header={<b>سوال : آیا گواهی بیمه نامه‌های تجهیزات الکترونیک مختص دستگاه‌های نو است؟</b>}>
                            <p>
                                <b>پاسخ : </b>
                                در صورتیکه دستگاه شما قبلاً باز نشده باشد و تعمیراتی بر روی آن صورت نگیرد تحت پوشش بیمه‌ای قرار خواهند گرفت.
                            </p>
                        </CollapsePanel>

                        <CollapsePanel key="12" header={<b>سوال : خسارت‌هایی که در بیمه ‌تجهیزات الکترونیک غیر قابل پرداخت می باشد کدامند؟</b>}>
                            <p>
                                <b>پاسخ : </b>
                                تمامی مواردی که در قسمت استثنائات گواهی بیمه نامه‌ای که در زمان خرید بیمه نامه به مشتری داده شده است. بسته به نوع طرح خریداری شده این موارد متغیر می‌باشد.
                            </p>
                        </CollapsePanel>

                        <CollapsePanel key="13" header={<b>سوال : مدت زمان پوشش بیمه‌نامه تجیهزات الکترونیک چقدر است؟</b>}>
                            <p>
                                <b>پاسخ : </b>
                                مدت زمان پوشش این بیمه ‌نامه از زمان خرید بیمه نامه به مدت یکسال می‌باشد.
                            </p>
                        </CollapsePanel>

                        {/*<CollapsePanel key="14" header={<b>سوال : آیا هنگام محاسبه و پرداخت خسارت، از ارزش تجهیزات الکترونیک من، استهلاک کسر می‌شود؟</b>}>
                            <p>
                                <b>پاسخ : </b>
                                خیر. این حق بیمه‌گزار است که خسارت خود را بر اساس ارزش روز دستگاه خود دریافت کند. محاسبه و پرداخت خسارت در بیمه تجهیزات الکترونیک بر اساس ارزش روز دستگاه در مقطع وقوع حادثه و پس از کسر فرانشیز مطابق شرایط مندرج در گواهی بیمه‌نامه صورت می‌پذیرد.
                            </p>
                            <p >
                                <b>نکته مهم : </b>
                                ملاک پرداخت خسارت منوط به ثبت خسارت بیمه‌گزاران محترم در سایت claim.zobhde.org و یا مراجعه حضوری و اعلام خسارت بصورت حضوری در شعب سراسر کشور می‌باشد.
                            </p>
                        </CollapsePanel>*/}
                    </Collapse>
                </div>
            </div>
        );
    }
}
